import TabsNavContainer from "components/shared/TabsNavContainer";
import TabLink from "hardcover-ui/components/TabLink";
import { PageSerializersAuthorsLayout } from "types/serializers";

export default function AuthorTabs({
  author,
}: {
  author: PageSerializersAuthorsLayout;
}) {
  return (
    <TabsNavContainer>
      <TabLink
        href={`/authors/${author.slug}`}
        size="lg"
        badge={author.booksCount}
        badgeClass="ml-2"
      >
        <>Books</>
      </TabLink>

      {author.seriesCount > 0 ? (
        <TabLink
          href={`/authors/${author.slug}/series`}
          size="lg"
          badge={author.seriesCount}
          badgeClass="ml-2"
        >
          <>Series</>
        </TabLink>
      ) : (
        false
      )}

      {author.compilationsCount > 0 ? (
        <TabLink
          href={`/authors/${author.slug}/collections`}
          size="lg"
          badge={author.compilationsCount}
          badgeClass="ml-2"
        >
          <>Collections</>
        </TabLink>
      ) : (
        false
      )}
    </TabsNavContainer>
  );
}